import React, { useEffect, useRef } from "react"
import { NylasSchedulerEditorElement, NylasSchedulerEditorProps } from "../../common/types/scheduling"
import "../styles/NylasSchedulerEditor.scss"
import CustomIdentityRequestWrapper from "./CustomIdentityRequestWrapper"

const NylasSchedulerEditor = (props: NylasSchedulerEditorProps) => {
    const schedulerEditorRef = useRef<NylasSchedulerEditorElement | null>(null)

    const handleCloseModal = () => {
        props.isModalChangedCallback(true)
    }

    const initializeSchedulerEditor = () => {
        if (!schedulerEditorRef.current) {
            console.warn("Scheduler Editor is not yet ready.")
            return
        }
    
        try {
            // Set the configurationId as a property and an attribute
            schedulerEditorRef.current.configurationId = props.configurationId
            schedulerEditorRef.current.setAttribute("configuration-id", props.configurationId)

            // Set scheduler properties
            schedulerEditorRef.current.schedulerPreviewLink = props.urlLink
            schedulerEditorRef.current.hideEditorTabs = ["participants", "bookingOptions", "bookingForm", "communications", "pageStyles"]
            schedulerEditorRef.current.defaultSchedulerConfigState = {
                selectedConfiguration: {
                    requires_session_auth: false,
                },
            }

            // Set the nylasApiRequest to enable authenticated requests
            const nylasApiRequest = new CustomIdentityRequestWrapper(props.externalAccountId, props.userName)
            schedulerEditorRef.current.nylasApiRequest = nylasApiRequest

            // Add the event listener here for schedulerConfigCloseClicked
            schedulerEditorRef.current.addEventListener("schedulerConfigCloseClicked", (e: Event) => {
                e.preventDefault()
                handleCloseModal()
            })

            schedulerEditorRef.current.addEventListener("schedulerEditorFormUpdated", () => {
                // At this point, the editor should be ready for use, so turn off the loading spinner
                props.isLoadingCallback(false)
            })

        } catch (error) {
            console.error("Error initializing Scheduler Editor:", error)
        }
    }

    useEffect(() => {
        // Wait for the component to be defined to initialize reference values
        if (window.customElements && window.customElements.whenDefined) {
            window.customElements.whenDefined("nylas-scheduler-editor").then(() => {
                initializeSchedulerEditor()
            })
        } else {
            // Fallback initialization
            setTimeout(initializeSchedulerEditor, 1000)
        }
    }, [props.externalAccountId, props.configurationId])

    return (
        <>
            {/* @ts-ignore */}
            <nylas-scheduler-editor ref={schedulerEditorRef} /> 
        </>
    )
}

export default NylasSchedulerEditor



// WEBPACK FOOTER //
// ./src/scheduling-page/nylasv3/NylasSchedulerEditor.tsx